<mat-dialog class="email-confirmation-dialog">
    <search-box
        [searchableList]="emails"
        (searchedList)="filterByEmail($event)"
        [searchDefaultText]="'Search'"
        [dialogHeader]="'Search Emails'"
        [searchableItemFieldName]="'loginEmail'"
    >
    </search-box>
    <mat-dialog-content>
        <cdk-virtual-scroll-viewport
            itemSize="68"
            minBufferPx="340"
            maxBufferPx="680"
            style="height: 40vh"
            class="mat-list"
        >
            <mat-list>
                <mat-list-item
                    *cdkVirtualFor="
                        let emp of filteredEmails;
                        index as i;
                        trackBy: emailTrack;
                        templateCacheSize: 0
                    "
                    class="mat-list-item"
                >
                    <span class="email-check-box">
                        <p-checkbox
                            class="mat-checkbox__native-control"
                            [(ngModel)]="emp.sendEmail"
                            [binary]="true"
                            (click)="removeEmail(emp, i)"
                        />
                    </span>
                    <label>{{ emp.loginEmail }}</label>
                </mat-list-item>
            </mat-list>
        </cdk-virtual-scroll-viewport>
    </mat-dialog-content>
    <div class="mat-dialog__actions">
        <button mat-raised-button data-mat-dialog-action="cancel" id="btn-cancel" mat-dialog-close>
            <div class="mat-button__ripple"></div>
            <span class="mat-button__label">Cancel</span>
        </button>
        <button
            mat-raised-button
            data-mat-dialog-action="confirm"
            id="btn-confirm"
            [mat-dialog-close]="true"
        >
            <div class="mat-button__ripple"></div>
            <span class="mat-button__label">Send {{ emails.length | number }} Email</span
            ><span *ngIf="emails.length > 1">s</span>
        </button>
    </div>
</mat-dialog>
